Ext.define('SA.model.createimport.ColumnDefinition', {
    constructor({headerName, friendlyName, type, format}) {
        this.headerName = headerName;
        this.friendlyName = friendlyName;
        this.type = type;
        this.format = format;
    },

    getFormat() {
        return this.format;
    },

    getFriendlyName() {
        return this.friendlyName;
    },

    getHeaderName() {
        return this.headerName;
    },

    getType() {
        return this.type;
    },

    isDataColumn() {
        return !!this.getType() && !this.isLocationColumn();
    },

    isDefaultNamed() {
        return !this.isFriendlyNamed();
    },

    isFriendlyNamed() {
        return this.getFriendlyName() !== '';
    },

    isLocationColumn() {
        return this.getType() === 'location';
    },

    serializeForRequest() {
        return {
            column: this.getHeaderName(),
            name: this.getFriendlyName() || this.getHeaderName(),
            type: this.getType(),
            format: this.getFormat()
        };
    },

    serializeForReview() {
        var isLocationColumn = this.isLocationColumn(),
            headerName = this.getHeaderName(),
            friendlyName = isLocationColumn ? null : this.getFriendlyName(),
            type = isLocationColumn ? 'Location ID' : SA.data.AttributeTypes.getTextForType(this.getType()),
            format = isLocationColumn ? null : SA.data.AttributeFormats.getTextForFormat(this.getFormat());

        return {headerName, friendlyName, type, format};
    }
});